import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Pagination, PaginationParams} from '../model/pagination';
import {LocationDto} from '../model/continent';
import {cleaningParams} from '../functions/cleaningParams';

@Injectable({
  providedIn: 'root'
})
export class HotelDtoService {
  constructor(private httpClient: HttpClient) {}

  getHotelList(params: PaginationParams): Observable<Pagination<LocationDto>>  {
    const cleanParams = cleaningParams(params);
    return this.httpClient.get<Pagination<LocationDto>>(`${environment.apiUrl}/public/hotel`,
      { params: { ...cleanParams } });
  }

  getHotel(id: number): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/hotel/${id}`);
  }

  getHotelByUrl(url: string): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/hotel/by-url/${url}`);
  }

  moveUp(id: number): Observable<boolean>  {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/hotel/move-up/${id}`, id);

  }

  moveDown(id: number): Observable<boolean> {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/hotel/move-down/${id}`, id);
  }

  saveHotelPhoto(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/hotel/file/${id}`, formData);
  }

  saveHotelCarousel(idHotel: number, idCarousel: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/hotel/file/${idHotel}/${idCarousel}`, formData);
  }

  deleteContinentCarousel(idHotel: number, idCarousel: number,) {
    return this.httpClient.delete(`${environment.apiUrl}/hotel/${idHotel}/${idCarousel}`);
  }

  saveHotel(Hotel: LocationDto): Observable<LocationDto> {
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/hotel`, Hotel);
  }

  delete(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/hotel/${id}`);
  }
}
